import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const EmbeddedChat = ({ uid }) => {
  const [iframeUrl, setIframeUrl] = useState('');
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (uid) {
      const sessionId = `session_${uid}_${Date.now()}`;
      // Use the environment variable for the backend URL
      const baseUrl = process.env.NODE_ENV === 'development' 
        ? 'http://127.0.0.1:8080'
        : process.env.REACT_APP_API_URL;
      
      setIframeUrl(`${baseUrl}/${sessionId}`);
    }
  }, [uid]);

  useEffect(() => {
    // Add message listener for navigation events from the iframe
    const handleMessage = (event) => {
      if (event.data.type === 'NAVIGATE_TO_PAST_INTERVIEWS') {
        // Navigate to the past interviews page
        navigate('/past-interviews');
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [navigate]);

  const handleIframeLoad = () => {
    setIframeLoaded(true);
  };

  const handleIframeError = () => {
    setError('Failed to load chat interface. Please try refreshing the page.');
  };

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-[50vh] md:h-full p-4 text-red-400">
        <p className="text-center">{error}</p>
      </div>
    );
  }

  return (
    <div className="relative w-full h-full flex flex-col overflow-hidden bg-[#0B0F17]">
      {(!iframeUrl || !iframeLoaded) && (
        <div className="absolute inset-0 flex items-center justify-center bg-[#0B0F17]/50 backdrop-blur-sm z-10">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        </div>
      )}
      {iframeUrl && (
        <iframe 
          src={iframeUrl}
          className={`w-full h-full border-none rounded-lg transition-opacity duration-300 ${
            iframeLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          onLoad={handleIframeLoad}
          onError={handleIframeError}
          title="Interview Chat"
          allow="microphone"
          style={{ 
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            backgroundColor: 'transparent'
          }}
        />
      )}
    </div>
  );
};

export default EmbeddedChat; 